import { axios } from "../../../lib/axios";

export const getSingleProduct = async (productId: any) => {
  const response = await axios.get(`/products/${productId}`);

  return response.data;
};
